import { ApplicationState } from 'framework/applicationState';
import { Event } from 'framework/entities/events';
import { RulesConfiguration } from 'controls/queryBuilder/ruleDefinition';

type IncidentEventArgs = {
	accountIds?: string[];
	includeSubaccounts?: boolean;
	filter?: RulesConfiguration;
};

const eventType = 'Incident';

export class IncidentEvent extends Event {
	static is(e: Event): e is IncidentEvent {
		return e.eventType == eventType;
	}

	static subscription(args: IncidentEventArgs) {
		args = args || {};

		return {
			eventType: eventType,
			accountIds: args.accountIds,
			includeSubaccounts: args.includeSubaccounts ?? ApplicationState.includeSubaccounts,
			filter: args.filter,
		};
	}
}
